import {getArticles} from "../services";
import {addArticles} from "../store/actions";
import {useEffect} from "react";
import {filterByLanguages} from "../utils/filterByLanguages";
import {filterByTags} from "../utils/filterByTags";
import {useSelector} from "react-redux";

interface Props {
    dispatch: Function
}

export const useGetArticles = ({dispatch}: Props) => {
    const {articles} = getArticles()

    // @ts-ignore
    const filteredLanguages = useSelector((state) => state.filters.languages)
    // @ts-ignore
    const filteredTags = useSelector((state) => state.filters.tags)

    useEffect(() => {
        const byLanguage = filterByLanguages({languages: filteredLanguages, items: articles})
        const articlesToDisplay = filterByTags({tags: filteredTags, items: byLanguage})
        dispatch(addArticles({articles: articlesToDisplay}))
    }, [dispatch, articles, filteredLanguages, filteredTags])
}